import { useState } from "react";

const useDeliveryForms = (props?) => {
  const { initialError = {}, initialInput = {} } = props || {};

  const [input, setInput] = useState<any>(initialInput);
  const [error, setError] = useState<any>(initialError);

  const handleFieldChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError(initialError);
    setInput({ ...input, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (value: string | string[], name: string) => {
    setError(initialError);
    setInput({ ...input, [name]: value });
  };

  return {
    input,
    setInput,
    error,
    setError,
    handleFieldChange,
    handleSelectChange,
  };
};

export default useDeliveryForms;
